// src/components/CourseCard.js
import React from 'react';
import { Box, Typography, Button, Paper, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CourseCard = ({ title, description, progress, status }) => {
  const theme = useTheme();

  const getProgressBarColor = (courseProgress: any) => {
    if (courseProgress === 100) return theme.palette.success.main;
    if (courseProgress < 50) return theme.palette.warning.main;
    return theme.palette.primary.main;
  };

  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box>
        <Typography variant="h5" sx={{ mb: 1, color: 'text.primary' }}>
          {title}
        </Typography>
        <Typography variant="body2" color="secondary.main" sx={{ mb: 2 }}>
          {description}
        </Typography>
      </Box>
      {progress !== undefined && (
        <Box sx={{ mt: 'auto' }}> {/* Push progress bar to bottom */}
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Progress: {progress}%
          </Typography>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 10,
              borderRadius: 25,
              bgcolor: '#e9ecef',
              '& .MuiLinearProgress-bar': { bgcolor: getProgressBarColor(progress) },
              mb: 2,
            }}
          />
        </Box>
      )}
      {progress !== 100 && (
        <Button
          variant="contained"
          sx={{
            bgcolor: 'primary.main',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '5px',
            fontWeight: 500,
            textTransform: 'none',
            alignSelf: 'flex-start', // Align button to start
          }}
        >
          Continue Learning
        </Button>
      )}
    </Paper>
  );
};

export default CourseCard;